


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { treatError } from '@/utils';
import eventBus from '@/utils/eventBus';

import Container from '@/components/atoms/Grid/Container.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Loading from '@/components/icons/Loading.vue';

import AdminService from '@/api/AdminService';
import HTTPStatus from '@/constants/httpStatus';

import FormOffer from '@/views/Offers/OfferCreation/Steps/FormOffer/FormOffer.vue';

@Component({
  components: {
    FilledButton,
    Container,
    Loading,
    FormOffer
  }
})
export default class AdminOfferDetail extends Vue {
  @Prop() readonly data!: any;

  offer: any = {};

  loading = false;
  adminService = new AdminService();

  get formDataDefault() {
    return {
      ...this.data.offer
    };
  }

  async handleSubmit() {
    eventBus.$emit('saveOffer');
  }

  async onSubmit(formattedPayload: any) {
    this.loading = true;

    try {
      const { status } = await this.adminService.updateOffer(this.offer.id, {
        ...formattedPayload,
        setActive: true
      });
      if (status === HTTPStatus.OK) {
        this.$notification('Success');
        eventBus.$emit('closeModal');
        eventBus.$emit('reloadOfferList');
        this.closeModal();
      }
    } catch (e) {
      console.error(e);
      treatError(e);
    } finally {
      this.loading = false;
    }
  }

  @Watch('data')
  async changedData() {
    this.offer = { ...this.formDataDefault };
  }

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }

  created() {
    this.changedData();
  }
}
